import { setTitle } from "@/effects";
import { MarketplaceDashboardList } from "@/marketplace/marketplace-dashboard-list";
import { MarketplaceHero } from "@/marketplace/marketplace-hero";
import { pageProfiles, startsWithExtraPath } from "@/route";
import { t } from "@lingui/core/macro";
import { useFlag } from "@openfeature/react-sdk";
import { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";

export default function MarketplacePage() {
  const { value: isMarketplaceEnabled } = useFlag("marketplace", false);
  const location = useLocation();
  const routePrefix = startsWithExtraPath(location.pathname);

  useEffect(() => {
    setTitle(t({ id: "marketplace.title", message: "Marketplace" }));
  }, []);

  if (!isMarketplaceEnabled) {
    return <Redirect to={`${routePrefix}${pageProfiles.asString()}`} />;
  }

  return (
    <>
      <MarketplaceHero />
      <MarketplaceDashboardList />
    </>
  );
}
